// PrivacyPage.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div
      style={{
        background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
        padding: "16px 8px",
      }}
    >
      <header
        style={{
          textAlign: "center",
          marginBottom: "32px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "800",
            color: "#047857",
            letterSpacing: "1px",
            marginBottom: "8px",
          }}
        >
          西鉄バスWatch!
        </h1>
        <p style={{ color: "#065f46", fontWeight: "500" }}>
          プライバシーポリシー
        </p>
      </header>

      <section
        style={{
          backgroundColor: "#d1fae5",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "32px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          lineHeight: "1.6",
          color: "#065f46",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#047857", marginBottom: "8px" }}>
          個人情報の取り扱いについて
        </h2>
        <p>
          当サイトでは、サービス向上およびコミュニティ運営の目的で、ユーザ登録時にメールアドレスなどの個人情報を収集・利用いたします。
        </p>
        <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
          <li>収集する情報: メールアドレス、ユーザ名、その他投稿情報</li>
          <li>利用目的: 投稿機能の提供、重要なお知らせの通知</li>
          <li>第三者提供: 法令に基づく場合を除き、第三者への提供は行いません</li>
          <li>安全管理: 個人情報は適切な管理を行い、不正アクセスや漏洩の防止に努めます</li>
        </ul>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#047857", margin: "16px 0 8px" }}>
          利用者の権利
        </h2>
        <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
          <li>登録情報の確認・修正・削除を希望される場合は、サイト運営者までお問い合わせください。</li>
        </ul>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#047857", margin: "16px 0 8px" }}>
          Cookieおよびアクセスログについて
        </h2>
        <p>
          当サイトでは、サービス向上のためにアクセスログを取得することがあります。Cookieを利用することがありますが、個人を特定する情報は含まれません。
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#047857", margin: "16px 0 8px" }}>
          プライバシーポリシーの変更
        </h2>
        <p>
          本ポリシーは予告なく変更されることがあります。変更後の内容は本ページにて公開されますので、定期的にご確認ください。
        </p>
      </section>

      {/* トップに戻るリンク */}
      <section style={{ textAlign: "center" }}>
        <Link
          to="/"
          style={{
            display: "inline-block",
            backgroundColor: "#fff",
            color: "#047857",
            padding: "8px 16px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "600",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e5ffe5")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
        >
          トップページへ戻る
        </Link>
      </section>
    </div>
  );
}
